<template>
  <div v-if="Object.keys(detail).length">
    <el-dialog
      title="信息详情"
      :visible.sync="dialogFormVisible"
      @close="emitClose"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="container">
        <div class="title">{{detail.college.name}}考研信息详情报告</div>
        <div class="molduar">
          <div class="molduar-title">专业信息</div>
          <div class="list-wrap">
            <div class="item">
              <div class="label">门类</div>
              <div class="value">{{detail.major_door.code}}{{detail.major_door.name}}</div>
            </div>
            <div class="item">
              <div class="label">学科</div>
              <div class="value">{{detail.major_discipline.code}}{{detail.major_discipline.name}}</div>
            </div>
            <div class="item">
              <div class="label">专业</div>
              <div class="value">{{detail.major.code}}{{detail.major.name}}</div>
            </div>
            <div class="item">
              <div class="label">学院</div>
              <div class="value">{{detail.academy.code}}{{detail.academy.name}}</div>
            </div>
            <div class="item">
              <div class="label">就业方向</div>
              <div class="value">{{detail.major.work_direction}}</div>
            </div>
            <div class="item">
              <div class="label">就业前景</div>
              <div class="value">{{detail.major.work_forward}}</div>
            </div>
          </div>

        </div>
        <div class="molduar">
          <div class="molduar-title">院校信息</div>
          <div class="list-wrap">
            <div class="item">
              <div class="label">地区</div>
              <div class="value">{{detail.college_province.area}}</div>
            </div>
            <div class="item">
              <div class="label">所在地</div>
              <div class="value">{{detail.college_province.name}}</div>
            </div>
            <div class="item">
              <div class="label">院校名称</div>
              <div class="value">{{detail.college.name}}</div>
            </div>
            <div class="item">
              <div class="label">院校类型</div>
              <div
                class="value"
                style="justify-content: flex-start;"
              >
                <el-tag
                  size="mini"
                  v-for="(item,index) in formateCategory(detail.college.category_ids)"
                  :key="index"
                >{{item}}</el-tag>
              </div>
            </div>
            <div class="item">
              <div class="label">综合排名</div>
              <div class="value">{{detail.college.college_rank?`${detail.college.college_rank}名`:'暂无'}}</div>
            </div>
            <div class="item">
              <div class="label">综合点评</div>
              <div class="value">{{detail.college.appraise}}</div>
            </div>
          </div>
        </div>
        <div class="molduar">
          <div class="molduar-title">国家线</div>
          <el-table
            class="table"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              label="A类地区"
              align="center"
            >
              <el-table-column
                label="总分"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_a_total||0}}分
                </template>
              </el-table-column>
              <el-table-column
                label="单科(满分=100分)"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_a_single100||0}}分
                </template>
              </el-table-column>
              <el-table-column
                label="单科(满分>100分)"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_a_single101||0}}分
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="B类地区"
              align="center"
            >
              <el-table-column
                label="总分"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_b_total||0}}分
                </template>
              </el-table-column>
              <el-table-column
                label="单科(满分=100分)"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_b_single100||0}}分
                </template>
              </el-table-column>
              <el-table-column
                label="单科(满分>100分)"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{scope.row.score_b_single101||0}}分
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div class="molduar">
          <div class="molduar-title">招生数据(全日制)</div>
          <div class="list-wrap">
            <div class="item">
              <div class="label">一志愿人数</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_user_count_first}}人</div>
            </div>
            <div class="item">
              <div class="label">调剂人数</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_user_count_adjust}}人</div>
            </div>
            <div class="item">
              <div class="label">录取最低分</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_low_score}}分</div>
            </div>
            <div class="item">
              <div class="label">录取最高分</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_high_score}}分</div>
            </div>
            <div class="item">
              <div class="label">调剂来源</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_adjust_source||'暂无'}}</div>
            </div>
            <div class="item">
              <div class="label">调剂去向</div>
              <div
                class="value"
                v-if="detail.recruit_cmp"
              >{{detail.recruit_cmp.college_major_adjust_target||'暂无'}}</div>
            </div>
          </div>
        </div>
        <div class="molduar">
          <div class="molduar-title">考试内容</div>
          <div class="list-wrap">
            <div class="item">
              <div class="label">研究方向</div>
              <div class="value">{{detail.directions}}</div>
            </div>
            <div
              class="item"
              style="justify-content:flex-end;"
            >
              <div class="label">考试科目</div>
              <div class="value">
                <div
                  v-for="(item,index) in formateSubjects(detail.subjects)"
                  :key="index"
                >
                  {{index+1}}.{{item.join(',')}}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label">参考书目</div>
              <div class="value">{{detail.reference_books||''}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <el-button @click="emitClose">取消</el-button>
        <el-button
          type="primary"
          @click="emitClose"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


import { coreOne } from "@/api/common";

export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {},
      detail: {},
      filters: {
        college_category_ids: [
          { value: 1, label: '985' },
          { value: 2, label: '211' },
          { value: 3, label: '一流大学' },
          { value: 4, label: '一流学科' },
          { value: 5, label: '自主划线' }
        ],
        recommend_level: [
          { value: 0, label: '二本三本可报考' },
          { value: 1, label: '一本二本可报考' },
          { value: 2, label: '211/双一流可报考' },
          { value: 3, label: '985/211可报考' },
          { value: 4, label: '不推荐报考' },
        ]
      },
      tableData: [],
    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    fetchDetail() {
      coreOne({ id: this.id }).then((res) => {
        this.detail = res
        const obj = {
          score_a_total: res.score_line.score_a_total,
          score_a_single100: res.score_line.score_a_single100,
          score_a_single101: res.score_line.score_a_single101,
          score_b_total: res.score_line.score_b_total,
          score_b_single100: res.score_line.score_b_single100,
          score_b_single101: res.score_line.score_b_single101,
        }
        this.tableData = [
          obj
        ]
      });
    },
    emitClose() {
      this.$emit("close");
    },
    formateCategory(val) {
      if (val) {
        let arr = val.split(',')
        let final = arr.map(v => {
          return this.filters.college_category_ids.find(t => {
            return t.value == v
          }).label
        })
        return final
      } else {
        return []
      }
    },
    formateSubjects(val) {
      if (val) {
        let arr = JSON.parse(val)
        return arr
      } else {
        return []
      }
    }

  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 16px;
  .molduar {
    margin-top: 24px;
    .molduar-title {
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
    }
    .list-wrap {
      display: flex;
      border-radius: 4px;
      flex-direction: column;
      border: solid 1px #dcdfe6;

      .item {
        display: flex;
        align-items: center;
        background: #ebeef5;

        & + .item {
          border-top: solid 1px #dcdfe6;
        }
        .label {
          width: 120px;
          height: 100%;
          padding: 0px 16px;
          border-right: solid 1px #dcdfe6;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #606266;
        }
        .value {
          height: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 16px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #303133;
          line-height: 24px;
          background: #fff;
        }
      }
    }
  }
  .title {
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #303133;
    margin-bottom: 48px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
}
.el-tag {
  & + .el-tag {
    margin-left: 8px;
  }
}
</style>